// removed by extract-text-webpack-plugin
module.exports = {"row":"_2Euz8","container":"_38ezl","content":"_370ct"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Privacy/Privacy.scss
// module id = 1293
// module chunks = 22